import React, { useEffect } from 'react'
import { Bar } from 'react-chartjs-2'
import '../../App.scss'
import './FinalStage.scss'
import { connect } from 'react-redux'
import { getOverallReturnsChartRequest } from '../../redux/trainer/trainer.actions'

const OverallReturn = ({ getOverallReturnsChartRequest, responseGetOverallReturnsChart }) => {

    const idGame = localStorage.getItem("game_id")
    useEffect(() => {
        getOverallReturnsChartRequest(idGame)
    }, [idGame])

    var finalData = []
    if (responseGetOverallReturnsChart && responseGetOverallReturnsChart.datasets.length > 0)
        responseGetOverallReturnsChart.datasets.map(d => {
            finalData.push(
                {
                    label: d.data.name,
                    fill: false,
                    backgroundColor: d.data.color,
                    borderColor: d.data.color,
                    borderWidth: 2,
                    data: d.data.points,
                    hidden: (!d.data.visible)
                }
            )
            return finalData
        })

    var state
    if (responseGetOverallReturnsChart)
        state = {
            labels: responseGetOverallReturnsChart.labels,
            datasets: finalData
        }

    const options = {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                fontSize: 11,
                boxWidth: 20,
                boxHeight: 2
            }
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    fontSize: 11,
                    callback: function (value) {
                        return value + "%"
                    }
                }
            }],
            xAxes: [{
                ticks: {
                    fontSize: 11
                }
            }]
        },
        tooltips: {
            enabled: true,
            callbacks: {
                title: function () {
                    return ""
                },
                label: function (tooltipItems, data) {
                    return tooltipItems.yLabel + "%";
                }
            }
        }
    }

    return (
        <div className="general_container final_stage">
            <h4 className="subtitle-stage">Overall Return</h4>
            <Bar data={state} options={options} />
        </div>
    )
}

const mapStateToProps = state => ({
    responseGetOverallReturnsChart: state.trainer.responseGetOverallReturnsChart
})

const mapDispatchToProps = dispatch => ({
    getOverallReturnsChartRequest: payload => dispatch(getOverallReturnsChartRequest(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(OverallReturn)